import { useEffect, useState } from 'react';
import { getUnmatchedCertificateCount } from '../../lib/api';

export const UNMATCHED_CERTIFICATES_CHANGED = 'unmatched-certificates:changed';

/** Dispatch after an assign/dismiss so the side-nav count refreshes without a reload. */
export function notifyUnmatchedCertificatesChanged(): void {
  window.dispatchEvent(new Event(UNMATCHED_CERTIFICATES_CHANGED));
}

/**
 * Pending unmatched-certificate count for the side nav. Fetches on mount (only when
 * enabled), on the changed event, and when refreshKey changes. Null until loaded or on
 * error (swallowed: the nav must never break).
 */
export function useUnmatchedCertificateCount(enabled: boolean, refreshKey?: string): number | null {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    if (!enabled) {
      setCount(null);
      return;
    }
    let cancelled = false;
    const load = () => {
      getUnmatchedCertificateCount()
        .then((r) => {
          if (!cancelled) setCount(r.pending);
        })
        .catch(() => {
          if (!cancelled) setCount(null);
        });
    };
    load();
    window.addEventListener(UNMATCHED_CERTIFICATES_CHANGED, load);
    return () => {
      cancelled = true;
      window.removeEventListener(UNMATCHED_CERTIFICATES_CHANGED, load);
    };
  }, [enabled, refreshKey]);

  return count;
}
